import { c as _c } from "react/compiler-runtime";
import { useState, useMemo, useCallback } from "react";
import type { ParseError, TokenRange } from "../types";
import { parseTokenExpressionToRanges, formatCanonical, BIGINT_ZERO, BIGINT_ONE, formatBigIntWithSeparators } from "../utils";
type UseNftTokenInputProps = {
  allowRanges: boolean;
  allSelected: boolean;
  contractTotalSupply?: bigint | null | undefined;
};
export function useNftTokenInput(t0) {
  const $ = _c(45);
  const {
    allowRanges,
    allSelected,
    contractTotalSupply
  } = t0;
  const [tokenInput, setTokenInput] = useState("");
  const [isEditingText, setIsEditingText] = useState(false);
  const [textValue, setTextValue] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [parseErrors, setParseErrors] = useState(t1);
  let t2;
  if ($[1] !== tokenInput) {
    t2 = tokenInput.trim();
    $[1] = tokenInput;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const trimmedTokenInput = t2;
  let t3;
  bb0: {
    if (!trimmedTokenInput) {
      let t4;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[3] = t4;
      } else {
        t4 = $[3];
      }
      let t5;
      if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
          ranges: t4 as TokenRange[],
          canonical: "",
          count: BIGINT_ZERO,
          errors: null as ParseError[] | null
        };
        $[4] = t5;
      } else {
        t5 = $[4];
      }
      t3 = t5;
      break bb0;
    }
    if (!allowRanges && trimmedTokenInput.includes("-")) {
      let t4;
      if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[5] = t4;
      } else {
        t4 = $[5];
      }
      const t5 = Math.max(trimmedTokenInput.length, 1);
      let t6;
      if ($[6] !== t5 || $[7] !== trimmedTokenInput) {
        t6 = {
          ranges: t4 as TokenRange[],
          canonical: "",
          count: BIGINT_ZERO,
          errors: [{
            input: trimmedTokenInput,
            index: 0,
            length: t5,
            message: "Ranges are disabled for this picker"
          }]
        };
        $[6] = t5;
        $[7] = trimmedTokenInput;
        $[8] = t6;
      } else {
        t6 = $[8];
      }
      t3 = t6;
      break bb0;
    }
    ;
    try {
      let count;
      let t5;
      let t6;
      if ($[9] !== trimmedTokenInput) {
        const canonicalRanges = parseTokenExpressionToRanges(trimmedTokenInput);
        count = canonicalRanges.reduce(_temp, BIGINT_ZERO);
        t5 = canonicalRanges;
        t6 = formatCanonical(canonicalRanges);
        $[9] = trimmedTokenInput;
        $[10] = count;
        $[11] = t5;
        $[12] = t6;
      } else {
        count = $[10];
        t5 = $[11];
        t6 = $[12];
      }
      let t7;
      if ($[13] !== count || $[14] !== t5 || $[15] !== t6) {
        t7 = {
          ranges: t5,
          canonical: t6,
          count,
          errors: null as ParseError[] | null
        };
        $[13] = count;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
      } else {
        t7 = $[16];
      }
      t3 = t7;
    } catch (t4) {
      const error = t4;
      if (Array.isArray(error)) {
        let t5;
        if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = [];
          $[17] = t5;
        } else {
          t5 = $[17];
        }
        let t6;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = {
            ranges: t5 as TokenRange[],
            canonical: "",
            count: BIGINT_ZERO,
            errors: error as ParseError[]
          };
          $[18] = t6;
        } else {
          t6 = $[18];
        }
        t3 = t6;
        break bb0;
      }
      let t5;
      if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        $[19] = t5;
      } else {
        t5 = $[19];
      }
      const t6 = Math.max(trimmedTokenInput.length, 1);
      let t7;
      if ($[20] !== t6 || $[21] !== trimmedTokenInput) {
        t7 = {
          ranges: t5 as TokenRange[],
          canonical: "",
          count: BIGINT_ZERO,
          errors: [{
            input: trimmedTokenInput,
            index: 0,
            length: t6,
            message: "Unable to parse token input"
          }]
        };
        $[20] = t6;
        $[21] = trimmedTokenInput;
        $[22] = t7;
      } else {
        t7 = $[22];
      }
      t3 = t7;
    }
  }
  const tokenPreview = t3;
  const canAddTokens = !allSelected && Boolean(trimmedTokenInput) && !tokenPreview.errors && tokenPreview.count > BIGINT_ZERO;
  let t4;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = new Intl.NumberFormat("en-US");
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  const numberFormatter = t4;
  let t5;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = value => typeof value === "number" ? numberFormatter.format(value) : formatBigIntWithSeparators(value);
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  const formatCount = t5;
  let t6;
  bb1: {
    if (allSelected) {
      if (contractTotalSupply) {
        let t7;
        if ($[25] !== contractTotalSupply) {
          t7 = formatCount(contractTotalSupply);
          $[25] = contractTotalSupply;
          $[26] = t7;
        } else {
          t7 = $[26];
        }
        const t8 = `All ${t7} tokens selected. Deselect to add specific tokens.`;
        let t9;
        if ($[27] !== t8) {
          t9 = {
            tone: "success" as const,
            text: t8
          };
          $[27] = t8;
          $[28] = t9;
        } else {
          t9 = $[28];
        }
        t6 = t9;
        break bb1;
      }
      let t7;
      if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
          tone: "success" as const,
          text: "All tokens selected. Deselect to add specific tokens."
        };
        $[29] = t7;
      } else {
        t7 = $[29];
      }
      t6 = t7;
      break bb1;
    }
    if (!trimmedTokenInput) {
      let t7;
      if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
          tone: "muted" as const,
          text: "Tip: Enter single tokens or ranges separated by commas."
        };
        $[30] = t7;
      } else {
        t7 = $[30];
      }
      t6 = t7;
      break bb1;
    }
    if (tokenPreview.errors) {
      const [firstError] = tokenPreview.errors;
      const detail = firstError?.input ? ` (${firstError.input})` : "";
      const t7 = `${firstError?.message ?? "Invalid token input"}${detail}`;
      let t8;
      if ($[31] !== t7) {
        t8 = {
          tone: "error" as const,
          text: t7
        };
        $[31] = t7;
        $[32] = t8;
      } else {
        t8 = $[32];
      }
      t6 = t8;
      break bb1;
    }
    let t7;
    if ($[33] !== tokenPreview.count) {
      t7 = formatCount(tokenPreview.count);
      $[33] = tokenPreview.count;
      $[34] = t7;
    } else {
      t7 = $[34];
    }
    const countLabel = t7;
    const canonical = tokenPreview.canonical || trimmedTokenInput;
    const plural = tokenPreview.count === BIGINT_ONE ? "token" : "tokens";
    const t8 = `Looks good: ${canonical} • Will add ${countLabel} ${plural}.`;
    let t9;
    if ($[35] !== t8) {
      t9 = {
        tone: "success" as const,
        text: t8
      };
      $[35] = t8;
      $[36] = t9;
    } else {
      t9 = $[36];
    }
    t6 = t9;
  }
  const helperState = t6;
  let t7;
  if ($[37] !== canAddTokens || $[38] !== helperState || $[39] !== isEditingText || $[40] !== parseErrors || $[41] !== textValue || $[42] !== tokenInput || $[43] !== tokenPreview) {
    t7 = {
      tokenInput,
      setTokenInput,
      isEditingText,
      setIsEditingText,
      textValue,
      setTextValue,
      parseErrors,
      setParseErrors,
      tokenPreview,
      canAddTokens,
      helperState,
      formatCount
    };
    $[37] = canAddTokens;
    $[38] = helperState;
    $[39] = isEditingText;
    $[40] = parseErrors;
    $[41] = textValue;
    $[42] = tokenInput;
    $[43] = tokenPreview;
    $[44] = t7;
  } else {
    t7 = $[44];
  }
  return t7;
}
function _temp(total, range) {
  return total + (range.end - range.start + BIGINT_ONE);
}